import React, { useContext } from "react";
import { useQuery } from "react-query";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { OnSellingRequest } from "../../../apis/on_selling/OnSellingRequest";
import DynamicBreadcrumb from "../../../components/breadcrumb/DynamicBreadcrumb";
import Chip from "../../../components/chip/Chip";
import Loading from "../../../components/loading/Loading";
import NavDetail from "../../../components/navbar/NavDetail";
import OnSellingContext from "../../../store/on_selling/OnSellingContext";
import { useQueries } from "../../../utils/query_searchParams/QuerySearchParams";
import { optRoutesSeeAll, queryparamsGroupProductSize } from "../helpers/list";
import OnSellingSeeAllperSize from "../on_selling_see_all_per_size/OnSellingSeeAllperSize";
import OnSellingSeeAllTable from "./OnSellingSeeAllTable";
import SeeAllFilter from "./SeeAllFilter";

const OnSellingSeeAll = () => {
  const query = useQueries(useLocation);
  const history = useHistory();
  const params: { id: string } = useParams();
  const { onSellingState, onSellingDispatch } = useContext(OnSellingContext);
  const { showFilterSeeAll, showSeeAllPerSize } = onSellingState;

  const { data, isLoading } = useQuery(
    [
      "getOnSellingGroupByProductSize",
      query.get("limit"),
      query.get("offset"),
      query.get("sort"),
      query.get("isAsc"),
      query.get("pre_order"),
      query.get("seller_id"),
      query.get("product_id"),
      query.get("exclude_seller_id"),
      query.get("selling_time_from"),
      query.get("selling_time_to"),
    ],
    () =>
      OnSellingRequest.getOnSellingGroupByProductSize(
        params.id,
        onSellingDispatch
      )
  );

  const { data: dataProduct, isLoading: loadProduct } = useQuery(
    "getProduct",
    () => OnSellingRequest.getProduct(params.id)
  );
  
  return (
    <>
      <NavDetail
        title1={"See all"}
        title2={"Seller"}
        handleBack={() => history.goBack()}
      />

      <div className="md:pt-28 sm:pt-20 pt-16">
        {showFilterSeeAll && <SeeAllFilter />}
        {showSeeAllPerSize.status && <OnSellingSeeAllperSize />}
        <DynamicBreadcrumb data={optRoutesSeeAll(params.id)} />
        {isLoading && loadProduct ? (
          <div className="flex justify-center mt-20">
            <Loading />
          </div>
        ) : (
          <section>
            <div>
              <div className="flex mt-14 mb-10 w-full">
                <div className="w-1/12 flex justify-center">
                  <img
                    src={dataProduct?.display_image_url}
                    alt={dataProduct?.slug}
                    className="border rounded-md p-4"
                  />
                </div>
                <div className="w-11/12 flex flex-col justify-evenly py-4 px-8">
                  <div>
                    <h1 className="text-xl">{dataProduct?.name}</h1>
                  </div>
                  <div>
                    <h1 className="font-rom text-sm">{`SKU: ${dataProduct?.code}`}</h1>
                  </div>
                </div>
              </div>

              <div>
                <div className="w-1/12">
                  <h1
                    onClick={() =>
                      onSellingDispatch({ type: "show_filter_see_all" })
                    }
                    className="hover:text-primary cursor-pointer"
                  >
                    Show Filter
                  </h1>
                </div>
                <div className="my-3">
                  <Chip
                    dispatchContext={onSellingDispatch}
                    stateContext={onSellingState}
                    queryParams={queryparamsGroupProductSize}
                  />
                </div>
              </div>
            </div>

            <div className="mb-16 mt-8">
              <OnSellingSeeAllTable data={data} />
            </div>
          </section>
        )}
      </div>
    </>
  );
};

export default OnSellingSeeAll;
